<template>
    <prism :language="language">
        <!--@slot codeblock-->
        <slot></slot>
    </prism>
</template>

<script>
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import Prism from 'vue-prism-component';

export default {
    name: "code-block",
    components: {
        Prism
    },
    props: {
        /**
         * Language to prism
         */
        language: {
            type: String,
            default: 'language-javascript',
        }
    }
}
</script>

<style scoped>

</style>
